/**
 * Created by tdunham on 8/11/2017.
 */


/**
 * This works for both the Player and Team data.  The
 * context in which it is used determines what data
 * it holds.  It is used to connect a "foreign" data
 * supplier's player and team information to the Fantasy
 * Sports player and team information.
 *
 * The ReST API vendor_player table holds the information
 * that links a vendor's identifier for a player with the
 * Fantasy Sports identifier for a player.
 *
 * The vendor_team table works the same way for a vendor's
 * identifier for a team.
 *
 * The 'id' field holds the number for the 'id' entry in
 * either vendor_player or vendor_team.
 *
 * The 'vendor_id' field holds the number for the 'id' entry
 * in the vendor_table table.
 *
 * The 'name' field holds the name of the vendor.
 *
 * The 'origin_id' field holds the number for the 'id' entry
 * in the player or team table.
 *
 * The 'vendor_link' field holds the "foreign" vendor's
 * identifier for the player or team specified in the other
 * fields.
 *
 * NOTE: Although this data arrangement may seem complex,
 * it allows us to enter (or delete) vendors and their data
 * easily.
 *
 */
export class VendorLink {

	public id: number;              // ID value in the Angular ReST API vendor_player or vendor_team table.
	public vendor_id: number;       // ID value in the vendor_table that matches the vendor we are holding data for.
	public name: string;            // The "foreign" vendor's name.
	public origin_id: number;       // ID value in the player or team table that matches the player or team for this data.
	public vendor_link: string;     // The "foreign" vendor's identifier for the player or team specified.

	constructor( values: Object = {} ) {
		Object.assign( this, values );
	}

}



// WEBPACK FOOTER //
// ./src/app/services/vendor/vendor-link.ts